"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.langMiddleware = void 0;
var __1 = require("..");
var helpers_1 = require("../api/helpers");
var langHelpers_1 = require("./langHelpers");
var debug = require("debug")("router:LanguagesMiddleware");
/**
 * LanguagesMiddleware
 * Patch all routes with ":lang" param
 * @param routes
 * @param showLangInUrl
 */
var langMiddleware = function (routes, showLangInUrl) {
    if (showLangInUrl === void 0) { showLangInUrl = __1.LangService.showLangInUrl(); }
    // return routes if langService is not init
    if (!__1.LangService.isInit)
        return routes;
    /**
     * Add :lang param on path
     * @param pPath
     * @param pShowLang
     */
    var patchLangParam = function (pPath, pShowLang) {
        return helpers_1.joinPaths([pShowLang && "/:lang", pPath !== "/" ? pPath : "/"]);
    };
    /**
     * Patch routes
     *  - Add "/:lang" param on each 1st level route
     *  - format path recurcively (on chidren if exist)
     * ex:
     *     {
     *      path: { en: "/home", fr: "/accueil" }
     *     },
     *
     *  return:
     *    {
     *      path: "/:lang/home",
     *      langPath: { en: "/:lang/home", fr: "/:lang/accueil" },
     *    }
  
     *
     */
    var patchRoutes = function (pRoutes, children) {
        if (children === void 0) { children = false; }
        return pRoutes.map(function (route) {
            var _a;
            var path = langHelpers_1.getLangPathByLang(route);
            var hasChildren = ((_a = route.children) === null || _a === void 0 ? void 0 : _a.length) > 0;
            var showLang = !children && showLangInUrl;
            var langPath = {};
            typeof route.path === "object" &&
                Object.keys(route.path).forEach(function (lang) {
                    langPath[lang] = patchLangParam(route.path[lang], showLang);
                });
            return __assign(__assign(__assign({}, route), { path: patchLangParam(path, showLang), langPath: Object.entries(langPath).length !== 0 ? langPath : null }), (hasChildren ? { children: patchRoutes(route.children, true) } : {}));
        });
    };
    return patchRoutes(routes);
};
exports.langMiddleware = langMiddleware;
